import React from "react"
import { useSelector } from "react-redux"
import OperatorOnly from "@/auth_descriptor/OperatorOnly"
import CruiseLineOnly from "@/auth_descriptor/CruiseLineOnly"
import { isBlank } from "@/utils"
import { getView } from "../selectors"
import OperatorTableRows from "./OperatorTableRows"
import CruiselineTableRows from "./CruiselineTableRows"

const InventoryAllocationTableRows = () => {
  const view = useSelector(getView)
  if (isBlank(view.inventory.allocationTableData.callDays)) {
    const season = view.selectedSeason
    return (
      <tr>
        <td>
          {season?.ended && (
            <h6 className="my-2">
              {`This season ran from ${season.startDate} to ${season.endDate}. Move the Start Date back to view its historic call days.`}
            </h6>
          )}
          <h6 className="my-2">
            {`${view.inventory.ship.name} has no call days in ${view.inventory.port.name} for the selected season, date range and other active filters.`}
          </h6>
        </td>
      </tr>
    )
  }

  return view.inventory.allocationTableData.callDays.map((call) => (
    <React.Fragment key={call.date}>
      <OperatorOnly>
        <OperatorTableRows date={call.date} />
      </OperatorOnly>
      <CruiseLineOnly>
        <CruiselineTableRows date={call.date} />
      </CruiseLineOnly>
    </React.Fragment>
  ))
}

export default InventoryAllocationTableRows
